<template>
  <div class="whatsapp-widget" :class="{ expanded: isExpanded }">
    <!-- Expandable Chat Panel -->
    <Transition name="chat-panel">
      <div v-if="isExpanded" class="chat-panel">
        <div class="chat-panel__header">
          <div class="chat-avatar">
            <img src="https://ui-avatars.com/api/?name=Inversun&background=25D366&color=fff&size=80" alt="Support" />
            <span class="online-dot"></span>
          </div>
          <div class="chat-info">
            <h4>Inversun Support</h4>
            <span class="status">
              <span class="status-dot"></span>
              Online
            </span>
          </div>
          <button class="close-btn" @click="isExpanded = false">
            <X :size="20" />
          </button>
        </div>

        <div class="chat-panel__body">
          <div class="chat-message chat-message--received">
            <p>Hello! Welcome to Inversun. How can we help you with your solar energy needs today?</p>
            <span class="message-time">Just now</span>
          </div>

          <div class="quick-replies">
            <p class="quick-replies__label">Quick replies:</p>
            <div class="quick-replies__buttons">
              <button
                v-for="(reply, index) in quickReplies"
                :key="index"
                class="quick-reply-btn"
                @click="sendMessage(reply)"
              >
                {{ reply }}
              </button>
            </div>
          </div>
        </div>

        <div class="chat-panel__footer">
          <a
            :href="whatsappUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="start-chat-btn"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            Continue on WhatsApp
          </a>
        </div>
      </div>
    </Transition>

    <!-- Main Toggle Button -->
    <button
      class="whatsapp-toggle"
      :class="{ 'is-expanded': isExpanded }"
      @click="toggleWidget"
      :title="isExpanded ? 'Close' : 'Chat with us on WhatsApp'"
    >
      <div class="pulse-ring"></div>
      <div class="pulse-ring pulse-ring--delayed"></div>
      <div class="toggle-icon">
        <Transition name="icon-rotate" mode="out-in">
          <X v-if="isExpanded" :size="26" key="close" />
          <svg v-else viewBox="0 0 24 24" fill="currentColor" width="28" height="28" key="whatsapp">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </Transition>
      </div>
    </button>

    <!-- Tooltip (shown when not expanded) -->
    <Transition name="tooltip">
      <span v-if="!isExpanded && showTooltip" class="whatsapp-tooltip">
        Need help? Chat with us!
      </span>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { X } from 'lucide-vue-next'

const phoneNumber = '96176984611'
const defaultMessage = 'Hello! I would like to inquire about your solar products.'

const isExpanded = ref(false)
const showTooltip = ref(false)

const quickReplies = [
  'Product inquiry',
  'Get a quote',
  'Installation help',
  'Technical support'
]

const whatsappUrl = computed(() => {
  const encodedMessage = encodeURIComponent(defaultMessage)
  return `https://wa.me/${phoneNumber}?text=${encodedMessage}`
})

const toggleWidget = () => {
  isExpanded.value = !isExpanded.value
  if (isExpanded.value) {
    showTooltip.value = false
  }
}

const sendMessage = (message) => {
  const encodedMessage = encodeURIComponent(`Hi! I'm interested in: ${message}`)
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank')
}

onMounted(() => {
  // Show tooltip after a delay
  setTimeout(() => {
    if (!isExpanded.value) {
      showTooltip.value = true
      // Hide after 5 seconds
      setTimeout(() => {
        showTooltip.value = false
      }, 5000)
    }
  }, 3000)
})
</script>

<style lang="scss" scoped>
$whatsapp: #25D366;
$whatsapp-dark: #128C7E;
$dark-900: #030712;

.whatsapp-widget {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 999;

  @media (max-width: 576px) {
    bottom: 20px;
    right: 20px;
  }
}

// Toggle Button
.whatsapp-toggle {
  position: relative;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, $whatsapp, $whatsapp-dark);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow:
    0 4px 20px rgba($whatsapp, 0.4),
    0 0 0 0 rgba($whatsapp, 0.5);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 10;

  &:hover {
    transform: scale(1.1);
    box-shadow:
      0 8px 30px rgba($whatsapp, 0.5),
      0 0 0 0 rgba($whatsapp, 0.5);
  }

  &.is-expanded {
    transform: scale(1);
    box-shadow: 0 4px 20px rgba($whatsapp, 0.4);

    .pulse-ring {
      display: none;
    }
  }

  @media (max-width: 576px) {
    width: 56px;
    height: 56px;
  }
}

.toggle-icon {
  position: relative;
  z-index: 2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

// Pulse Animation Rings
.pulse-ring {
  position: absolute;
  inset: -4px;
  border: 3px solid $whatsapp;
  border-radius: 50%;
  animation: pulse-ring 2s ease-out infinite;
  opacity: 0;

  &--delayed {
    animation-delay: 1s;
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

// Icon Rotate Transition
.icon-rotate-enter-active,
.icon-rotate-leave-active {
  transition: all 0.3s ease;
}

.icon-rotate-enter-from {
  opacity: 0;
  transform: rotate(-90deg) scale(0.8);
}

.icon-rotate-leave-to {
  opacity: 0;
  transform: rotate(90deg) scale(0.8);
}

// Tooltip
.whatsapp-tooltip {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 12px;
  padding: 0.75rem 1.25rem;
  background: white;
  border-radius: 12px;
  box-shadow:
    0 4px 20px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  font-size: 0.9rem;
  font-weight: 500;
  color: $dark-900;
  white-space: nowrap;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    right: 24px;
    width: 16px;
    height: 16px;
    background: white;
    border-radius: 3px;
    transform: rotate(45deg);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  }

  @media (max-width: 576px) {
    display: none;
  }
}

.tooltip-enter-active,
.tooltip-leave-active {
  transition: all 0.3s ease;
}

.tooltip-enter-from,
.tooltip-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

// Chat Panel
.chat-panel {
  position: absolute;
  bottom: 80px;
  right: 0;
  width: 360px;
  background: white;
  border-radius: 20px;
  box-shadow:
    0 10px 40px rgba(0, 0, 0, 0.2),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  overflow: hidden;

  @media (max-width: 576px) {
    width: calc(100vw - 40px);
    right: -10px;
    bottom: 70px;
  }

  &__header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, $whatsapp, $whatsapp-dark);
    color: white;
  }

  &__body {
    padding: 1.25rem;
    min-height: 180px;
    max-height: 300px;
    overflow-y: auto;
    background: #f0f2f5;
  }

  &__footer {
    padding: 1rem 1.25rem;
    background: white;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
}

.chat-avatar {
  position: relative;
  width: 50px;
  height: 50px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .online-dot {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 12px;
    height: 12px;
    background: #00e676;
    border: 2px solid white;
    border-radius: 50%;
  }
}

.chat-info {
  flex: 1;

  h4 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 0.15rem;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.8rem;
    opacity: 0.9;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    background: #00e676;
    border-radius: 50%;
    animation: pulse-dot 2s ease-in-out infinite;
  }
}

@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.close-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: rotate(90deg);
  }
}

// Chat Message
.chat-message {
  max-width: 85%;
  padding: 0.9rem 1.1rem;
  border-radius: 16px;
  margin-bottom: 1rem;
  position: relative;

  &--received {
    background: white;
    border-bottom-left-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    p {
      color: $dark-900;
      font-size: 0.95rem;
      line-height: 1.5;
      margin-bottom: 0.35rem;
    }

    .message-time {
      display: block;
      font-size: 0.75rem;
      color: #999;
    }
  }
}

// Quick Replies
.quick-replies {
  &__label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 0.75rem;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}

.quick-reply-btn {
  padding: 0.6rem 1rem;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50px;
  font-size: 0.85rem;
  color: $whatsapp-dark;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: $whatsapp;
    border-color: $whatsapp;
    color: white;
    transform: translateY(-2px);
  }
}

// Start Chat Button
.start-chat-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.9rem 1.5rem;
  background: linear-gradient(135deg, $whatsapp, $whatsapp-dark);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba($whatsapp, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba($whatsapp, 0.4);
  }
}

// Chat Panel Transition
.chat-panel-enter-active,
.chat-panel-leave-active {
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.chat-panel-enter-from,
.chat-panel-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.95);
}
</style>
